import { components } from 'react-select';

import { ValueContainerProps } from './ValueContainer.types';
import { useStyles } from './ValueContainer.styles';

export const ValueContainer = ({ children, ...rest }: ValueContainerProps) => {
  const styles = useStyles();

  return (
    <components.ValueContainer css={styles.root} {...rest}>
      {children}
    </components.ValueContainer>
  );
};
